//TODO: Get these values from database
/*
  Reference Kind
  ----------------
  id, name
  1, SERVICE_TYPE
  2, RECEIPT_STATUS

*/
export default  {
    SERVICE_TYPE: 1,
    RECEIPT_STATUS: 2
}